var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type === 'html')?_c('div',{domProps:{"innerHTML":_vm._s(_vm.defaultHtmlTemplate)}}):_c('pre',{staticClass:"pre"},[_vm._v("  "+_vm._s(_vm.defaultTextTemplate)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }